import { render, staticRenderFns } from "./BPAStudentForm.vue?vue&type=template&id=a8099ca8&scoped=true&"
import script from "./BPAStudentForm.vue?vue&type=script&lang=js&"
export * from "./BPAStudentForm.vue?vue&type=script&lang=js&"
import style0 from "./BPAStudentForm.vue?vue&type=style&index=0&id=a8099ca8&prod&scoped=true&lang=scss&"
import style1 from "./BPAStudentForm.vue?vue&type=style&index=1&id=a8099ca8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8099ca8",
  null
  
)

export default component.exports